import { allTimezones, TimezoneSelectOptions } from "react-timezone-select";
import { PillVariants } from "../components/pill";
import { UserType, UserType2 } from "../redux/features/auth/auth.types";
import {
  EventCategories,
  EventStatus,
} from "../redux/features/event/event.types";
import { UserStatus } from "./types";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const clientAuthTokenCookieKey = "tkktAuK";
export const adminAuthTokenCookieKey = "adTkktAuK";
export const clientProfileCookieKey = "tkktPK";
export const adminProfileCookieKey = "adTkktPK";
export const welcomeModalKey = "isWelcomeModalShown";
export const OTPMAXTIME = 90;
export const MAX_SIZE_MB = 2 * 1024 * 1024;
export const CLOUDINARY_URL = process.env.REACT_APP_CLOUDINARY_URL;
export const CLOUDINARY_PRESET = "tikket_preset";
export const PRIMARY_COLOR = "#04000A";
export const DEFAULT_EVENT_IMAGE_URL =
  "http://res.cloudinary.com/kneenk/image/upload/v1741163355/tikket_uploads/mw16ijeje8drvsbrrvcj.jpg";
export const PAYSTACK_URL =
  "https://dashboard.paystack.com/#/login?next=app.home.dashboard";
export const WARNING_TICKET_QUANTITY = 10;
export const MAX_PURCHASE_QUANTITY = 5;
export const FEE_PERCENTAGE = 0.05;
export const FEE_PERCENTAGE_TEXT = `${FEE_PERCENTAGE * 100}% + ₦100`;
export const SKELETON_BASE_COLOR = "#E5E7EB";
export const SKELETON_HIGHLIGHT_COLOR = "#ffffff";
export const TICKET_COLOR_OPTIONS = [
  "#65007f,#f9eafd",
  "#2051CA,#F0F6FF",
  "#BE0606,#FDF2F2",
  "#CB8E00,#FFF6D6",
  "#008035,#D8F6E4",
  "#697BA7,#F4F7FA",
]; //i.e ["#pillTextColor,#pillBgColor"]
export const guestEventsLSKey = "guestEvents";
export const guestProfileLSKey = "guestProfile";
export const paidTooltip = {
  id: "paid-tooltip",
  text: "This is the total amount we’ve paid into your payout account.",
};
export const pendingPayoutTooltip = {
  id: "pending-payout-tooltip",
  text: `This is how much you’ve made that hasn’t been paid into your payout account.\nN.B. Payouts that fall on weekends and public holidays would be paid the next working day.`,
};

export const domain = window.location.hostname;

export const APP_SCHEME = window.location.protocol;

export const APP_PORT = window.location.port;

export const isLocalhost =
  domain.includes("localhost") || domain.includes("192.");

export const APP_SUBDOMAIN_PREFIX = domain.includes("vercel.app")
  ? "app-"
  : "app.";

export const MAIN_DOMAIN = domain.replace(APP_SUBDOMAIN_PREFIX, "");

export const APP_SUBDOMAIN = isLocalhost
  ? `${domain}`
  : `${APP_SUBDOMAIN_PREFIX}${domain}`;

export const userStatusPillMap: Record<
  UserStatus,
  { text: string; variant: PillVariants }
> = {
  active: {
    text: "ACTIVE",
    variant: "green",
  },
  inactive: {
    text: "DEACTIVATED",
    variant: "red",
  },
  pending: {
    text: "PENDING",
    variant: "grey",
  },
  suspended: {
    text: "SUSPENDED",
    variant: "yellow",
  },
};

export const eventStatusPillMap: Record<
  EventStatus,
  { text: string; variant: PillVariants }
> = {
  upcoming: {
    text: "UPCOMING",
    variant: "blue",
  },
  draft: {
    text: "DRAFT",
    variant: "grey",
  },
  completed: {
    text: "PAST",
    variant: "green",
  },
};

export const userTypePillMap: Record<
  UserType | UserType2,
  { text: string; variant: PillVariants }
> = {
  organiser: {
    text: "Organizer",
    variant: "purple",
  },
  guest: {
    text: "Guest",
    variant: "grey",
  },
  attendee: {
    text: "Guest",
    variant: "grey",
  },
};

export const eventCategories: {
  name: EventCategories;
  value: EventCategories;
}[] = [
  {
    name: "General",
    value: "General",
  },
  {
    name: "Kids & Teens",
    value: "Kids & Teens",
  },
  {
    name: "Fashion",
    value: "Fashion",
  },
  {
    name: "Media & Film",
    value: "Media & Film",
  },
  {
    name: "Sports & Fitness",
    value: "Sports & Fitness",
  },
  {
    name: "Government & Politics",
    value: "Government & Politics",
  },
  {
    name: "Community",
    value: "Community",
  },
  {
    name: "Charity & Causes",
    value: "Charity & Causes",
  },
  {
    name: "Education",
    value: "Education",
  },
  {
    name: "Concert",
    value: "Concert",
  },
  {
    name: "Career",
    value: "Career",
  },
  {
    name: "Religion & Spirituality",
    value: "Religion & Spirituality",
  },
  {
    name: "Finance & Investment",
    value: "Finance & Investment",
  },
  {
    name: "Business",
    value: "Business",
  },
  {
    name: "Party",
    value: "Party",
  },
  {
    name: "Tech & Science",
    value: "Tech & Science",
  },
  {
    name: "Startups",
    value: "Startups",
  },
  {
    name: "Food & Drinks",
    value: "Food & Drinks",
  },
  {
    name: "Arts & Culture",
    value: "Arts & Culture",
  },
  {
    name: "Music & Entertainment",
    value: "Music & Entertainment",
  },
];

export const timezones = {
  ...allTimezones,
  "Europe/Berlin": "Frankfurt",
  "Africa/Lagos": "Lagos",
};

export const tzOptions: TimezoneSelectOptions = {
  labelStyle: "abbrev",
  timezones: timezones,
  displayValue: "UTC",
};

export const clientTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
